import HomeIcon from "@mui/icons-material/Home";
import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { PageLayout } from "../../layouts/PageLayout";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <PageLayout>
      <Stack
        direction="column"
        spacing={3}
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: "60vh" }}
      >
        <Typography variant="h2" color="text.primary">
          Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" textAlign="center">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </Typography>
        <Button
          variant="contained"
          size="large"
          startIcon={<HomeIcon />}
          onClick={() => navigate("/")}
        >
          Go to Dashboard
        </Button>
      </Stack>
    </PageLayout>
  );
}
